import type { Components, Theme } from '@mui/material/styles';
import type { Tokens } from '@zeus/themes';

import { createAccordionStyles } from './components/createAccordionStyles';
import { createAlertStyles } from './components/createAlertStyles';
import { createAppBarStyles } from './components/createAppBarStyles';
import { createAutocompleteStyles } from './components/createAutocompleteStyles';
import { createAvatarGroupStyles } from './components/createAvatarGroupStyles';
import { createButtonGroupStyles } from './components/createButtonGroupStyles';
import { createButtonStyles } from './components/createButtonStyles';
import { createCardStyles } from './components/createCardStyles';
import { createCheckboxStyles } from './components/createCheckboxStyles';
import { createChipStyles } from './components/createChipStyles';
import { createDialogStyles } from './components/createDialogStyles';
import { createIconButtonStyles } from './components/createIconButtonStyles';
import { createListStyles } from './components/createListStyles';
import { createMenuStyles } from './components/createMenuStyles';
import { createPaginationStyles } from './components/createPaginationStyles';
import { createPickerStyles } from './components/createPickerStyles';
import { createRadioStyles } from './components/createRadioStyles';
import { createRatingStyles } from './components/createRatingStyles';
import { createSliderStyles } from './components/createSliderStyles';
import { createSwitchStyles } from './components/createSwitchStyles';
import { createTableCellStyles } from './components/createTableCellStyles';
import { createTableSortLabelStyles } from './components/createTableSortLabelStyles';
import { createTabStyles } from './components/createTabStyles';
import { createTextareaStyles } from './components/createTextareaStyles';
import { createToggleButtonStyles } from './components/createToggleButtonStyles';
import { createTooltipStyles } from './components/createTooltipStyles';
import { createTypographyStyles } from './components/createTypographyStyles';

export function createComponents(tokens: Tokens) {
  return {
    ...createAccordionStyles(),
    ...createAlertStyles(tokens),
    ...createAutocompleteStyles(),
    ...createAvatarGroupStyles(),
    ...createButtonStyles(tokens),
    ...createButtonGroupStyles(),
    ...createTypographyStyles(tokens),
    ...createAppBarStyles(tokens),
    ...createCheckboxStyles(),
    ...createRadioStyles(),
    ...createIconButtonStyles(),
    ...createMenuStyles(),
    ...createRatingStyles(tokens),
    ...createToggleButtonStyles(),
    ...createTooltipStyles(),
    ...createTabStyles(),
    ...createChipStyles(tokens),
    ...createSliderStyles(),
    ...createSwitchStyles(),
    ...createCardStyles(),
    ...createDialogStyles(),
    ...createPickerStyles(),
    ...createListStyles(),
    ...createPaginationStyles(),
    ...createTableCellStyles(),
    ...createTableSortLabelStyles(),
    ...createTextareaStyles(),
  } as Required<Components<Theme>>;
}
